<template>
    <div>
        <el-form  :model="form" label-width="80px"  class="event-form" :rules="rules" ref="form">
            <el-form-item label="下一节点" v-if="!isRejected&&!isObserve">
                <el-input v-model="this.form.nextStop" disabled></el-input>
            </el-form-item>
            <!--处理组-->
            <el-form-item label="处理组" v-if="!isRejected&&!isObserve" prop="currentDepartment">
                <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                    <el-option v-for="item in departmentList" :key="item.index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
                <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
            </el-form-item>
            <!--处理人-->
            <el-form-item label="处理人" v-if="!isRejected&&!isObserve" prop="currentHandlerName">
                <div class="el-form__inline">
                    <el-input v-model="form.currentHandlerName" disabled></el-input>
                    <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                    <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                </div>
            </el-form-item>
            <el-form-item label="完成程度" v-if="!isObserve" prop="completionDegree">
                <el-select v-model="form.completionDegree" placeholder="请选择">
                    <el-option v-for="item in completionDegree" :key="item.id" :label="item.cname"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="label" prop="handleComment">
                <el-input type="textarea" v-model="form.handleComment"></el-input>
            </el-form-item>
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./problem.service"
    import notifyTab from "../common/notifyTab.vue"
    import {getRules} from "./problem.rules";
    const rules=getRules()
    export default {
        props:{
            type:String,
            callback:Function,
            serialNumber:String,
            isObserve:Boolean,
            isRejected:Boolean
        },
        components:{ notifyTab },
        data() {
            return {
                rules:rules,
                form:{
                    completionDegree:"",
                    handleComment:"",
                    notify:[],
                    nextStop:'',
                    currentDepartment:"",
                    currentHandlerName:'',
                    currentHandlerId:'',
                },
                notifyUserid:[],
                departmentList:[],      // 处理组
                dis_user:true,
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                label:"备注",
                isSubmit:false
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            }
        },
        created() {
            // if(this.type == "reset"){
            //     this.$modal.title = "重新开启";
            //     this.label = "处理意见"
            // };
            console.log("hhh");
            console.log(this.dictionary);
            this.getDepartment()
            if (this.isObserve){
                this.$modal.title = "观察完成";
                this.form.nextStop='处理完成'
            }else{
                this.form.nextStop='观察中'
            }
            if (this.isRejected){
                this.$modal.title = "驳回";
                this.form.nextStop='创建'
            }
        },
        methods: {
            // 服务组
            getDepartment(){
                // console.log(this.type);
                // console.log(this.status);
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                services.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                let groupId=this.form.currentDepartment
                this.form.currentHandlerName = ''
                this.userTasksTotal=''
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // 组员页面
            toRequesterList(){
                let id = this.form.currentDepartment;
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:`${id}`,
                        exceptMe:this.exceptMe,
                        currentHandler:this.currentHandler
                    }
                })
            },
            getRequester(obj){
                this.form.currentHandlerName = obj.name;
                this.form.currentHandlerId = obj.internalUserid;
                let userid=this.form.currentHandlerId
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // submit(){
            //     this.isSubmit=true
            //     let handle
            //     if (!this.isRejected){
            //         handle = this.isObserve? "观察完成" : "处理完成"
            //     } else{
            //         handle='驳回'
            //     }
            //     this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
            //     let params = {
            //         ...this.form,
            //         notify:this.notifyUserid,
            //         serialNumber:this.serialNumber,
            //         handle:handle,
            //         currentHandler:this.form.currentHandlerId
            //     }
            //     if(!this.form.handleComment){
            //         this.isSubmit=false
            //         this.$message.error('请填写备注')
            //     }else{
            //         services.handle(params).then(res => {
            //             this.$message.success(this.$modal.title+"成功");
            //             this.close(true);
            //         }).catch(err => {
            //             this.isSubmit=false
            //             this.$message.error(err.message)
            //         })
            //     }
            // },
            submit(){
                    this.isSubmit=true
                    let handle
                    if (!this.isRejected){
                        handle = this.isObserve? "观察完成" : "处理完成"
                    } else{
                        handle='驳回'
                    }
                    this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                    let params = {
                        ...this.form,
                        notify:this.notifyUserid,
                        serialNumber:this.serialNumber,
                        handle:handle,
                        currentHandler:this.form.currentHandlerId
                    }
                this.$refs['form'].validate(valid=>{
                    if (valid){
                        services.handle(params).then(res => {
                            this.$message.success(this.$modal.title+"成功");
                            this.close(true);
                        }).catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message)
                        })
                    } else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')
                    }
                })
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },

            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
